<template>
  <v-theme-provider theme="dark" with-background >
    <router-view />
  </v-theme-provider>
</template>

<script>
export default {
  name: "AdminLayout"
}
</script>

<style scoped>

</style>